import React from 'react'
import Navbar from '../inc/Navbar'
import KidCCD3Fortedrops from "../images/Kid CC-D3 Forte Drops photo.jpg";
import kidCCd3forte from "../images/Kid CC-D3 Forte Drops.jpg"
function Kidccforte() {
  return (
    <div>
      <Navbar />
      <br />
      <br />
      <br />
      <br />
      <img src={KidCCD3Fortedrops} className="d-block w-100" alt="KidCCD3Fortedrops" />
      <div className='LysorichSyrup'>
        <div className="album py-1">
          <div className="container">
            <center>
              <h2 className='mt-3'>Kid CC-D3 Forte Drops</h2>
              <p>Cholecalciferol (Vitamin D3)
Oral Drops 300 IU/ml</p>
            </center>
          </div>
        </div>
      </div>
      <b />

      <div className="album py-1">
        <div className="container">
          <center>
            <h1><b>Kid CC-D3 Forte Drops</b> Uses </h1>
          </center>
        </div>
      </div>

      <div className="album py-1">
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <img src={kidCCd3forte} className="img-fluid " alt="kidCCd3forte" />

            </div>

            <div className="col-md-8">
              <br/>
              <br/>
              <h5 style={{color:"#0499a0"}} className='mb-2'><b>Regulates the immune system</b></h5>
               <h5 style={{color:"#0499a0"}}  className='mb-2'><b>Maintains healthy nerves and muscles</b></h5>
               <h5 style={{color:"#0499a0"}}  className='mb-2'><b>Promotes healthy growth & development in infancy & childhood</b></h5>

                      <h5 style={{color:"#0499a0"}}  className='mb-0'><b>Stimulates the body to absorb calcium for strong bones & teeth</b></h5>

            </div>
          </div>
          <br/>
          <br/>
          <br/>
      
        </div>
        </div>
        <br />
      </div>
      )
}

      export default Kidccforte